export enum Unit {
  FLOW = 'flow',
  LEVEL = 'level',
}
